(function () {
  var stickyHeaders = new Map();

  function initSticky(header) {
    if (stickyHeaders.has(header)) return;
    var wrapper = header.closest('.shopify-section-group-header-group');
    var main = header.querySelector('.zj-site-header__main');
    if (!wrapper || !main) return;
    var marker = document.createElement('span');
    marker.className = 'zj-header-sticky-marker';
    marker.setAttribute('aria-hidden', 'true');
    wrapper.before(marker);
    var observer;
    function refresh() {
      if (observer) observer.disconnect();
      var pinnedTop = parseFloat(getComputedStyle(wrapper).top) || 0;
      var mainOffset = main.getBoundingClientRect().top - wrapper.getBoundingClientRect().top;
      var boundary = pinnedTop + mainOffset;
      header.classList.toggle('is-pinned', main.getBoundingClientRect().top <= boundary && marker.getBoundingClientRect().top < 0);
      observer = new IntersectionObserver(function (entries) {
        header.classList.toggle('is-pinned', entries[0].intersectionRatio === 0 && main.getBoundingClientRect().top <= boundary);
      }, { rootMargin: (-pinnedTop - marker.getBoundingClientRect().height) + 'px 0px 0px 0px', threshold: [0, 1] });
      observer.observe(marker);
    }
    var resize = new ResizeObserver(refresh);
    resize.observe(wrapper);
    refresh();
    stickyHeaders.set(header, function () { observer.disconnect(); resize.disconnect(); marker.remove(); });
  }

  function init(root) {
    if (!root || root.dataset.zjAnnReady) return;
    var items = [].slice.call(root.querySelectorAll('.zj-site-header__announcement-item'));
    if (items.length < 2) return;
    root.dataset.zjAnnReady = 'true';
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var delay = (parseFloat(root.dataset.zjSpeed) || 5) * 1000;
    var index = 0, timer = null, hovered = false, focused = false, editing = false;

    function show(next) {
      items[index].classList.remove('is-active');
      index = next;
      items[index].classList.add('is-active');
    }
    function stop() { clearInterval(timer); timer = null; }
    function start() {
      if (timer || hovered || focused || editing) return;
      timer = setInterval(function () {
        if (!root.isConnected) { stop(); return; }
        show((index + 1) % items.length);
      }, delay);
    }

    root.addEventListener('mouseenter', function () { hovered = true; stop(); });
    root.addEventListener('mouseleave', function () { hovered = false; start(); });
    root.addEventListener('focusin', function () { focused = true; stop(); });
    root.addEventListener('focusout', function () { focused = false; start(); });
    root.addEventListener('shopify:block:select', function (e) {
      var target = items.indexOf(e.target);
      editing = true; stop();
      if (target > -1) show(target);
    });
    root.addEventListener('shopify:block:deselect', function () { editing = false; start(); });

    start();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-zj-announcements]').forEach(init);
    (scope || document).querySelectorAll('.zj-site-header').forEach(initSticky);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    stickyHeaders.forEach(function (cleanup, header) {
      if (e.target.contains(header)) { cleanup(); stickyHeaders.delete(header); }
    });
  });
})();
